export default __webpack_public_path__ + "static/media/mountain-header.be2dec67.png";